import { render } from "./BasketContent.vue?vue&type=template&id=41b5f035&scoped=true"
import script from "./BasketContent.vue?vue&type=script&lang=js"
export * from "./BasketContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b5f035"]])

export default __exports__